(() => {
  'use strict';

  const MARKETPLACES = ['Amazon', 'eBay', 'AliExpress', 'OTTO', 'POCO', 'AOSOM', 'AEG', 'Autopflege.de', 'Teppich.de', 'Blauhimmels', 'Vorteilshop'];
  const DEFAULT_API = 'https://blauhimmels-price-proxy.vercel.app/api';
  const money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });


  // Adapted from DealPilot's universal product facet logic (read-only source).
  const UNIVERSAL_BRANDS = ['Apple','Samsung','Google','Xiaomi','Huawei','OnePlus','Sony','LG','Philips','Bosch','Siemens','Miele','AEG','Dyson','Rowenta','DeLonghi','Krups','Jura','Nespresso','Nintendo','PlayStation','Xbox','LEGO','Nike','Adidas','Puma','New Balance','Asics','Reebok','Vans','Converse','The North Face','Jack Wolfskin','IKEA','HOMCOM','Makita','DeWalt','Einhell','Metabo','Milwaukee','Gardena','Kärcher','Karcher','Weber','Tefal','WMF','Braun','Oral-B','Nivea','L’Oréal',"L'Oreal",'Maybelline','Garnier','Canon','Nikon','Fujifilm','Epson','Brother','HP','Lenovo','Dell','Acer','Asus','MSI','Intel','AMD','Nvidia','Logitech','JBL','Bose','Sennheiser','Beats','Anker','Ugreen','Belkin','Continental','Michelin','Goodyear','Pirelli','Bridgestone','Britax','Cybex','Maxi-Cosi','Ravensburger','Playmobil','Schleich'];
  const UNIVERSAL_COLORS = [['Schwarz',['schwarz','black']],['Weiß',['weiss','weiß','white']],['Grau',['grau','grey','gray']],['Silber',['silber','silver']],['Gold',['gold']],['Blau',['blau','blue']],['Rot',['rot','red']],['Grün',['grun','grün','green']],['Gelb',['gelb','yellow']],['Orange',['orange']],['Rosa',['rosa','pink']],['Lila',['lila','violett','purple']],['Beige',['beige','creme','cream']],['Braun',['braun','brown']],['Transparent',['transparent','clear']],['Mehrfarbig',['mehrfarbig','multicolor','bunt']]];
  const UNIVERSAL_MATERIALS = [['Leder',['leder','leather']],['Kunstleder',['kunstleder','pu leder','vegan leather']],['Baumwolle',['baumwolle','cotton']],['Polyester',['polyester']],['Wolle',['wolle','wool']],['Samt',['samt','velvet']],['Cord',['cord','corduroy']],['Holz',['holz','wood']],['Metall',['metall','metal','stahl','steel']],['Aluminium',['aluminium','aluminum']],['Glas',['glas','glass']],['Kunststoff',['kunststoff','plastic','abs']],['Keramik',['keramik','ceramic']],['Silikon',['silikon','silicone']],['Gummi',['gummi','rubber']]];
  const ATTRIBUTE_LABELS = {platform:'Plattform',format:'Format / Edition',language:'Sprache',brand:'Marke',color:'Farbe',material:'Material',storage:'Speicher',ram:'Arbeitsspeicher',screenSize:'Displaygröße',dimensions:'Maße',volume:'Volumen',weight:'Gewicht / Inhalt',voltage:'Spannung',power:'Leistung',size:'Größe',packSize:'Packungsgröße',features:'Eigenschaften',audience:'Zielgruppe'};
  const ATTRIBUTE_PRIORITY = ['platform','format','language','brand','size','storage','ram','material','screenSize','dimensions','volume','weight','voltage','power','packSize','features','audience','color'];
  const COLOR_SWATCHES = {Schwarz:'#111111',Weiß:'#ffffff',Grau:'#8b8f97',Silber:'linear-gradient(135deg,#f5f7fa,#aeb4be)',Gold:'linear-gradient(135deg,#f8e7a1,#b78108)',Blau:'#2467d6',Rot:'#d93a45',Grün:'#278b4b',Gelb:'#f2cf38',Orange:'#f08a28',Rosa:'#ee78ad',Lila:'#8256c8',Beige:'#d9c7a7',Braun:'#7a4a2b',Transparent:'linear-gradient(135deg,#fff 0 42%,#cfd5dc 42% 58%,#fff 58%)',Mehrfarbig:'conic-gradient(#e34b4b,#e7cb3d,#42a55d,#3d79d8,#a24cc2,#e34b4b)'};
  const normalizeSearchText = (value) => text(value).toLocaleLowerCase('de-DE').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9äöüß]+/g,' ').replace(/\s+/g,' ').trim();
  function addAttribute(target,id,value){ const clean=text(value); if(!clean) return; const arr=target[id]||[]; if(!arr.includes(clean)) target[id]=[...arr,clean]; }
  function extractUniversalAttributes(offer){
    const title=normalizeSearchText(offer.title); const a={};
    for(const brand of UNIVERSAL_BRANDS){ const b=normalizeSearchText(brand); if(new RegExp(`(?:^|\\s)${b.replace(/[.*+?^${}()|[\\]\\]/g,'\\$&')}(?:\\s|$)`).test(title)){addAttribute(a,'brand',brand);break;} }
    for(const [label,terms] of UNIVERSAL_COLORS) if(terms.some(t=>title.includes(normalizeSearchText(t)))) addAttribute(a,'color',label);
    for(const [label,terms] of UNIVERSAL_MATERIALS) if(terms.some(t=>title.includes(normalizeSearchText(t)))) addAttribute(a,'material',label);
    for(const m of title.matchAll(/(?:^|\s)(\d{1,4})\s*(gb|tb)(?:\s|$)/g)) addAttribute(a,'storage',`${m[1]} ${m[2].toUpperCase()}`);
    for(const m of title.matchAll(/(?:^|\s)(\d{1,3})\s*gb\s*(?:ram|arbeitsspeicher)(?:\s|$)/g)) addAttribute(a,'ram',`${m[1]} GB`);
    for(const m of [...title.matchAll(/(?:^|\s)(\d{1,3}(?:[.,]\d)?)\s*(?:zoll|inch|")/g)].slice(0,2)) addAttribute(a,'screenSize',`${m[1].replace(',','.')} Zoll`);
    for(const m of [...title.matchAll(/(?:^|\s)(\d{1,4})\s*[x×]\s*(\d{1,4})(?:\s*[x×]\s*(\d{1,4}))?\s*(mm|cm|m)(?:\s|$)/g)].slice(0,2)) addAttribute(a,'dimensions',`${m[1]} × ${m[2]}${m[3]?` × ${m[3]}`:''} ${m[4]}`);
    for(const m of [...title.matchAll(/(?:^|\s)(\d+(?:[.,]\d+)?)\s*(ml|cl|l|liter)(?:\s|$)/g)].slice(0,2)) addAttribute(a,'volume',`${m[1].replace(',','.')} ${m[2]==='liter'?'L':m[2].toUpperCase()}`);
    for(const m of [...title.matchAll(/(?:^|\s)(\d+(?:[.,]\d+)?)\s*(mg|g|kg)(?:\s|$)/g)].slice(0,2)) addAttribute(a,'weight',`${m[1].replace(',','.')} ${m[2]}`);
    for(const m of [...title.matchAll(/(?:^|\s)(\d+(?:[.,]\d+)?)\s*v(?:olt)?(?:\s|$)/g)].slice(0,2)) addAttribute(a,'voltage',`${m[1].replace(',','.')} V`);
    for(const m of [...title.matchAll(/(?:^|\s)(\d{2,5})\s*w(?:att)?(?:\s|$)/g)].slice(0,2)) addAttribute(a,'power',`${m[1]} W`);
    for(const m of title.matchAll(/(?:^|\s)(xxxs|xxs|xs|s|m|l|xl|xxl|xxxl|3xl|4xl|5xl)(?:\s|$)/g)) addAttribute(a,'size',m[1].toUpperCase());
    for(const m of [...title.matchAll(/(?:eu|grosse|größe|size)\s*(\d{2,3})(?:[.,]5)?(?:\s|$)/g)].slice(0,2)) addAttribute(a,'size',`EU ${m[1]}`);
    for(const m of [...title.matchAll(/(?:^|\s)(\d{1,3})\s*(?:er\s*)?(?:pack|stk|stuck|stück|teile|pcs)(?:\s|$)/g)].slice(0,2)) addAttribute(a,'packSize',`${m[1]} Stück`);
    const terms=(id,defs)=>defs.forEach(([label,words])=>{if(words.some(w=>title.includes(normalizeSearchText(w)))) addAttribute(a,id,label);});
    terms('platform',[['PlayStation 5',['ps5','playstation 5']],['PlayStation 4',['ps4','playstation 4']],['Xbox Series X|S',['xbox series x','xbox series s','xbox series']],['Xbox One',['xbox one']],['Nintendo Switch',['nintendo switch','switch oled']],['PC',['pc game','pc spiel','windows pc']]]);
    terms('format',[['Disc',['disc','disk','blu ray game']],['Download',['download code','digital code','download']],['Standard Edition',['standard edition']],['Deluxe Edition',['deluxe edition']],["Collector's Edition",['collector edition','collectors edition']],['Hardcover',['hardcover']],['Taschenbuch',['taschenbuch','paperback']],['Gebunden',['gebunden']],['Hörbuch',['horbuch','hoerbuch','audiobook','audio cd']],['E-Book',['ebook','e book','kindle','epub']]]);
    terms('language',[['Deutsch',['deutsch','german','deutsche ausgabe']],['Englisch',['englisch','english','english edition']]]);
    terms('features',[['5G',['5g']],['4G / LTE',['4g','lte']],['eSIM',['esim']],['Dual-SIM',['dual sim','dual-sim']],['Bluetooth',['bluetooth']],['WLAN / Wi-Fi',['wlan','wifi','wi fi']],['USB-C',['usb c','usb-c']],['OLED',['oled']],['QLED',['qled']],['4K',['4k','uhd']],['HDR',['hdr']],['Akku',['akku','batterie']],['Wasserdicht',['wasserdicht','waterproof']]]);
    terms('audience',[['Damen',['damen','frau','women','female']],['Herren',['herren','mann','men','male']],['Kinder',['kinder','kind','kids','jungen','mädchen','madchen']],['Unisex',['unisex']]]);
    return a;
  }
  function facetSortValue(value){ const c=text(value).toLowerCase().replace(',','.'); const size={xxs:1,xs:2,s:3,m:4,l:5,xl:6,xxl:7,'2xl':7,xxxl:8,'3xl':8,xxxxl:9,'4xl':9}[c]; if(size!==undefined)return [0,size,0]; const eu=c.match(/^eu\s*(\d+(?:\.\d+)?)$/); if(eu)return[0,Number(eu[1]),0]; const nums=c.match(/-?\d+(?:\.\d+)?/g)||[]; if(!nums.length)return[1,Infinity,0]; let n=Number(nums[0]); if(/\btb\b/.test(c))n*=1048576; else if(/\bgb\b/.test(c))n*=1024; else if(/\bkg\b/.test(c))n*=1000; else if(/\bmg\b/.test(c))n/=1000; return[0,n,Number(nums[1]||0)]; }
  function compareFacetValues(a,b){ const x=facetSortValue(a),y=facetSortValue(b); return x[0]-y[0]||x[1]-y[1]||x[2]-y[2]||a.localeCompare(b,'de',{numeric:true,sensitivity:'base'}); }
  function buildUniversalFacets(offers){ const all=new Map(); offers.forEach(o=>{ const attrs=extractUniversalAttributes(o); Object.entries(attrs).forEach(([id,vals])=>{const m=all.get(id)||new Map(); new Set(vals).forEach(v=>m.set(v,(m.get(v)||0)+1)); all.set(id,m);});}); return Array.from(all.entries()).map(([id,m])=>({id,label:ATTRIBUTE_LABELS[id]||id,values:Array.from(m.entries()).map(([value,count])=>({value,count})).filter(x=>x.count>0).sort((a,b)=>compareFacetValues(a.value,b.value)).slice(0,12)})).filter(f=>f.values.length>=2).sort((a,b)=>{const ai=ATTRIBUTE_PRIORITY.indexOf(a.id),bi=ATTRIBUTE_PRIORITY.indexOf(b.id);return(ai<0?99:ai)-(bi<0?99:bi);}).slice(0,10); }
  function offerMatchesAttributeFilters(offer,filters){ const attrs=extractUniversalAttributes(offer); return Object.entries(filters).every(([id,selected])=>!selected.length || selected.some(v=>(attrs[id]||[]).includes(v))); }

  const text = (value) => typeof value === 'string' ? value.trim() : '';
  const number = (value) => {
    if (value === null || value === undefined) return null;
    if (typeof value === 'string' && value.trim() === '') return null;
    const parsed = Number(String(value).replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : null;
  };

  function uniqueStrings(values) {
    return Array.from(new Set((Array.isArray(values) ? values : []).map(text).filter(Boolean)));
  }

  function conditionGroup(condition) {
    const normalized = text(condition).toLowerCase();
    if (!normalized) return 'unknown';
    if (normalized.includes('generalüberholt') || normalized.includes('generaluberholt') || normalized.includes('refurb') || normalized.includes('renewed')) return 'refurbished';
    if (normalized.includes('gebraucht') || normalized.includes('used') || normalized.includes('pre-owned') || normalized.includes('preowned')) return 'used';
    if (normalized.includes('neu') || normalized === 'new' || normalized.includes('brand new')) return 'new';
    return 'unknown';
  }

  function normalizeOffer(raw, index, shopHint) {
    if (!raw || typeof raw !== 'object') return null;
    const shop = text(raw.shop) || text(raw.marketplace) || text(raw.provider) || shopHint || 'Händler';
    const title = text(raw.title) || text(raw.name) || text(raw.productTitle);
    if (!title) return null;

    const price = number(raw.price) ?? number(raw.currentPrice) ?? number(raw.salePrice);
    const shipping = number(raw.shippingPrice) ?? number(raw.shipping) ?? 0;
    const shippingKnown = typeof raw.shippingPriceKnown === 'boolean' ? raw.shippingPriceKnown : number(raw.shippingPrice) !== null;
    const total = number(raw.totalPrice) ?? (price !== null ? price + shipping : null);
    if (total === null) return null;
    const originalPriceCandidate = number(raw.originalPrice) ?? number(raw.oldPrice) ?? number(raw.listPrice) ?? number(raw.rrpPrice) ?? number(raw.uvp);
    const originalPrice = originalPriceCandidate !== null && originalPriceCandidate > total ? originalPriceCandidate : null;

    const rawImages = Array.isArray(raw.images) ? raw.images : Array.isArray(raw.imageUrls) ? raw.imageUrls : [];
    const image = text(raw.image) || text(raw.imageUrl) || text(raw.thumbnail) || text(raw.picture) || null;
    const images = uniqueStrings([image, ...rawImages]);
    const rating = number(raw.rating) ?? number(raw.ratingValue) ?? number(raw.sellerRating) ?? number(raw.reviewRating);

    return {
      id: text(raw.sourceId) || text(raw.id) || text(raw.asin) || text(raw.ebayItemId) || `${shop}-${index}-${title}`,
      shop,
      title,
      category: text(raw.category) || text(raw.categoryName) || '',
      description: text(raw.description) || text(raw.shortDescription) || text(raw.productDescription) || '',
      price: price ?? total,
      originalPrice,
      shippingPrice: shipping,
      shippingPriceKnown: shippingKnown,
      totalPrice: total,
      currency: text(raw.currency) || 'EUR',
      image,
      images,
      url: text(raw.url) || text(raw.affiliateUrl) || text(raw.productUrl) || text(raw.itemWebUrl) || text(raw.link) || '',
      condition: text(raw.condition) || '',
      available: raw.available !== false,
      deliveryText: text(raw.deliveryText) || text(raw.deliveryTime) || text(raw.availabilityText) || '',
      sellerName: text(raw.sellerName) || '',
      relevanceScore: number(raw.relevanceScore) ?? 0,
      matchType: text(raw.matchType) || '',
      rating: rating ?? 0,
    };
  }

  function responseOffers(data, shopHint) {
    const collected = [];
    const add = (value, hint) => {
      if (!Array.isArray(value)) return;
      value.forEach((item, index) => {
        const offer = normalizeOffer(item, index, hint);
        if (offer) collected.push(offer);
      });
    };
    if (Array.isArray(data)) add(data, shopHint);
    else if (data && typeof data === 'object') {
      add(data.offers, shopHint); add(data.products, shopHint); add(data.results, shopHint); add(data.items, shopHint);
      if (data.data && typeof data.data === 'object') {
        add(data.data.offers, shopHint); add(data.data.products, shopHint); add(data.data.results, shopHint); add(data.data.items, shopHint);
      }
    }
    const deduped = new Map();
    collected.forEach((offer) => {
      const key = `${offer.shop.toLowerCase()}::${offer.id}`;
      if (!deduped.has(key) || offer.images.length > deduped.get(key).images.length) deduped.set(key, offer);
    });
    return Array.from(deduped.values());
  }

  function escapeHtml(value) {
    return String(value ?? '').replace(/[&<>'"]/g, (char) => ({ '&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;' })[char]);
  }
  function safeUrl(value) {
    try { const url = new URL(value, window.location.origin); return ['http:', 'https:'].includes(url.protocol) ? url.href : ''; }
    catch { return ''; }
  }


  // DealPilot-orientierte sichtbare Ergebniskategorien (read-only Quelle, fuer Blauhimmels adaptiert).
  const CATEGORY_PRIORITY = [
    'shoes','shoe-accessories','consumables','smartphones','phone-cases','phone-protection','phone-charging','phone-accessories',
    'sofas','sofa-beds','corner-sofas','vacuum-cleaners','hair-care','dyson-filters','dyson-batteries','dyson-brushes',
    'power-tools','drill-bits','tool-batteries','tool-chargers','lego-sets','lego-parts','fans','stand-fans','table-fans','tower-fans','ceiling-fans','usb-fans',
    'products','accessories','spare-parts','other-results'
  ];
  const CATEGORY_LABELS = {
    shoes:'Schuhe & Sneaker','shoe-accessories':'Schuhzubehör',consumables:'Pflege',smartphones:'Smartphones','phone-cases':'Hüllen',
    'phone-protection':'Schutzglas & Folien','phone-charging':'Laden & Strom','phone-accessories':'Audio & Zubehör',sofas:'Sofas',
    'sofa-beds':'Schlafsofas','corner-sofas':'Ecksofas & Wohnlandschaften','vacuum-cleaners':'Staubsauger','hair-care':'Haarpflege',
    'dyson-filters':'Filter','dyson-batteries':'Akkus','dyson-brushes':'Bürsten & Aufsätze','power-tools':'Akkuschrauber & Bohrmaschinen',
    'drill-bits':'Bohrer & Bits','tool-batteries':'Akkus','tool-chargers':'Ladegeräte','lego-sets':'LEGO Sets','lego-parts':'Einzelteile & Motoren',
    fans:'Ventilatoren','stand-fans':'Standventilatoren','table-fans':'Tischventilatoren','tower-fans':'Turmventilatoren','ceiling-fans':'Deckenventilatoren',
    'usb-fans':'USB- & Mini-Ventilatoren',accessories:'Zubehör','spare-parts':'Ersatzteile','other-results':'Weitere Ergebnisse'
  };
  const includesAnyNormalized = (value, terms) => terms.some((term) => value.includes(normalizeSearchText(term)));
  function titleCaseCategory(value) {
    return text(value).split(/\s+/).filter(Boolean).map((word) => {
      const lower=word.toLocaleLowerCase('de-DE');
      const keep={iphone:'iPhone',ipad:'iPad',macbook:'MacBook',airpods:'AirPods',lego:'LEGO',usb:'USB',oled:'OLED',qled:'QLED',tv:'TV',ps5:'PS5',xbox:'Xbox'};
      return keep[lower] || lower.charAt(0).toLocaleUpperCase('de-DE') + lower.slice(1);
    }).join(' ');
  }
  function dynamicMainCategoryLabel(query) {
    const q=normalizeSearchText(query);
    const groups=[
      [/\b(iphone|smartphone|handy|mobiltelefon|galaxy|pixel)\b/,'Smartphones'],[/\b(fernseher|tv|oled|qled)\b/,'Fernseher'],
      [/\b(laptop|notebook|macbook|chromebook)\b/,'Laptops & Notebooks'],[/\b(tablet|ipad)\b/,'Tablets'],
      [/\b(kopfhörer|kopfhoerer|headphone|earbuds|airpods)\b/,'Kopfhörer'],[/\b(lautsprecher|soundbar|speaker)\b/,'Lautsprecher'],
      [/\b(kamera|digitalkamera|spiegelreflex|systemkamera)\b/,'Kameras'],[/\b(drucker)\b/,'Drucker'],
      [/\b(waschmaschine)\b/,'Waschmaschinen'],[/\b(trockner|wäschetrockner|waeschetrockner)\b/,'Wäschetrockner'],
      [/\b(kühlschrank|kuehlschrank)\b/,'Kühlschränke'],[/\b(kaffeemaschine|kaffeevollautomat|espressomaschine)\b/,'Kaffeemaschinen'],
      [/\b(fahrrad|e bike|ebike)\b/,'Fahrräder'],[/\b(reifen|winterreifen|sommerreifen)\b/,'Reifen'],[/\b(parfum|parfüm|duft)\b/,'Parfums'],
      [/\b(jacke|mantel|parka)\b/,'Jacken & Mäntel'],[/\b(hose|jeans)\b/,'Hosen & Jeans'],[/\b(kleid)\b/,'Kleider'],[/\b(uhr|smartwatch)\b/,'Uhren'],
      [/\b(grill)\b/,'Grills'],[/\b(rasenmäher|rasenmaeher)\b/,'Rasenmäher'],[/\b(matratze)\b/,'Matratzen'],[/\b(bett)\b/,'Betten'],
      [/\b(schreibtisch)\b/,'Schreibtische'],[/\b(stuhl|sessel)\b/,'Stühle & Sessel'],[/\b(kinderwagen)\b/,'Kinderwagen'],[/\b(puzzle)\b/,'Puzzles']
    ];
    for (const [pattern,label] of groups) if (pattern.test(q)) return label;
    return titleCaseCategory(query) || 'Produkte';
  }
  function categoryLabel(id, query) { return id === 'products' ? dynamicMainCategoryLabel(query) : (CATEGORY_LABELS[id] || titleCaseCategory(id)); }
  function categoryIdForOffer(offer, query) {
    const q=normalizeSearchText(query); const t=normalizeSearchText(`${offer.title} ${offer.category || ''}`);
    if (/\b(schuh|schuhe|sneaker|air max)\b/.test(q)) {
      if (includesAnyNormalized(t,['schuhpflege','textilpflege','imprägnierspray','impraegnierspray','schuhcreme','lederpflege'])) return 'consumables';
      if (includesAnyNormalized(t,['schnürsenkel','schnuersenkel','einlegesohle','schuhzubehör','schuhzubehor','shoe accessory','schuhspanner'])) return 'shoe-accessories';
      if (includesAnyNormalized(t,['schuh','schuhe','sneaker','trainer','sandale','pantolette','pantoffel','hausschuh','badeschuh','stiefel','boots','slipper','clog'])) return 'shoes';
      return 'other-results';
    }
    if (q.includes('iphone') || /\b(smartphone|handy)\b/.test(q)) {
      if (includesAnyNormalized(t,['hülle','huelle','case','cover','bumper'])) return 'phone-cases';
      if (includesAnyNormalized(t,['schutzglas','panzerglas','schutzfolie','displayfolie'])) return 'phone-protection';
      if (includesAnyNormalized(t,['ladegerät','ladegeraet','ladekabel','adapter','powerbank','magsafe','wireless charger'])) return 'phone-charging';
      if (includesAnyNormalized(t,['mikrofon','headset','kopfhörer','kopfhoerer','earbuds','halterung','ständer','staender'])) return 'phone-accessories';
      if (includesAnyNormalized(t,['iphone','smartphone','galaxy','pixel','oneplus','xiaomi','redmi','fold','flip'])) return 'smartphones';
      return 'other-results';
    }
    if (q.includes('dyson')) {
      if (t.includes('filter')) return 'dyson-filters'; if (includesAnyNormalized(t,['akku','batterie'])) return 'dyson-batteries';
      if (includesAnyNormalized(t,['bürste','buerste','düse','duese','aufsatz'])) return 'dyson-brushes';
      if (includesAnyNormalized(t,['airwrap','supersonic','haartrockner','haarstyler'])) return 'hair-care';
      if (includesAnyNormalized(t,['staubsauger','vacuum','wash g1','v15','v12','v11','v10','v8'])) return 'vacuum-cleaners';
      return 'other-results';
    }
    if (/\b(akkuschrauber|bohrschrauber|bohrmaschine)\b/.test(q)) {
      if (includesAnyNormalized(t,['bit','bohrer','bohrerset'])) return 'drill-bits'; if (includesAnyNormalized(t,['akku','batterie'])) return 'tool-batteries';
      if (includesAnyNormalized(t,['ladegerät','ladegeraet'])) return 'tool-chargers'; if (includesAnyNormalized(t,['akkuschrauber','bohrschrauber','schlagbohr','bohrmaschine'])) return 'power-tools';
      return 'other-results';
    }
    if (q.includes('lego')) {
      if (includesAnyNormalized(t,['motor','liftarm','einzelteil','ersatzteil'])) return 'lego-parts';
      if (includesAnyNormalized(t,['lego','technic','klemmbaustein'])) return 'lego-sets'; return 'other-results';
    }
    if (/\b(ventilator|lüfter|luefter|fan)\b/.test(q)) {
      if (includesAnyNormalized(t,['deckenventilator','decken ventilator'])) return 'ceiling-fans'; if (includesAnyNormalized(t,['turmventilator','tower fan','säulenventilator','saeulenventilator'])) return 'tower-fans';
      if (includesAnyNormalized(t,['standventilator','stand ventilator'])) return 'stand-fans'; if (includesAnyNormalized(t,['tischventilator','tisch ventilator'])) return 'table-fans';
      if (includesAnyNormalized(t,['usb','mini ventilator','handventilator'])) return 'usb-fans'; if (includesAnyNormalized(t,['ventilator','lüfter','luefter','fan'])) return 'fans'; return 'other-results';
    }
    if (/\b(sofa|couch)\b/.test(q)) {
      if (includesAnyNormalized(t,['schlafsofa','sofabett'])) return 'sofa-beds'; if (includesAnyNormalized(t,['ecksofa','wohnlandschaft'])) return 'corner-sofas'; if (includesAnyNormalized(t,['sofa','couch'])) return 'sofas'; return 'other-results';
    }
    const secondary=[
      ['consumables',['pflege','reiniger','reinigung','politur','wachs','tinte','toner','patrone','kartusche','beutel']],
      ['spare-parts',['ersatzteil','reparaturteil','dichtung','scharnier','ersatzakku','display ersatz']],
      ['accessories',['zubehör','zubehor','kabel','adapter','halter','halterung','tasche','rucksack','bezug','aufsatz']]
    ];
    for (const [id,terms] of secondary) if (includesAnyNormalized(t,terms)) return id;
    const tokens=q.split(' ').filter((token)=>token.length>=3);
    if (tokens.length && tokens.some((token)=>t.includes(token))) return 'products';
    return 'other-results';
  }

  document.querySelectorAll('[data-bh-price-comparison]').forEach((root) => {
    const form = root.querySelector('[data-bh-pc-search-form]');
    const queryInput = root.querySelector('[data-bh-pc-query]');
    const suggestionsPanel = root.querySelector('[data-bh-pc-suggestions]');
    const status = root.querySelector('[data-bh-pc-status]');
    const summary = root.querySelector('[data-bh-pc-summary]');
    const workspace = root.querySelector('[data-bh-pc-workspace]');
    const grid = root.querySelector('[data-bh-pc-grid]');
    const loading = root.querySelector('[data-bh-pc-loading]');
    const empty = root.querySelector('[data-bh-pc-empty]');
    const counts = Array.from(root.querySelectorAll('[data-bh-pc-count]'));
    const setCount = (value) => counts.forEach((node) => { node.textContent = value; });
    const categoryBar = root.querySelector('[data-bh-pc-categories]');
    const merchants = root.querySelector('[data-bh-pc-merchants]');
    const conditions = root.querySelector('[data-bh-pc-conditions]');
    const attributeFacetsHost = root.querySelector('[data-bh-pc-attribute-facets]');
    const sort = root.querySelector('[data-bh-pc-sort]');

    const sortLabels = {
      relevance: { full: 'Relevanz & bester Gesamtpreis', compact: 'Relevanz & Gesamtpreis' },
      'price-asc': { full: 'Günstigster Gesamtpreis inkl. Versand', compact: 'Günstigster Preis' },
      'price-desc': { full: 'Höchster Gesamtpreis inkl. Versand', compact: 'Höchster Preis' },
      'rating-desc': { full: 'Beste Bewertung', compact: 'Beste Bewertung' }
    };
    function updateResponsiveSortLabels() {
      const compact = window.matchMedia('(max-width: 420px)').matches;
      Array.from(sort.options).forEach((option) => {
        const labels = sortLabels[option.value];
        if (labels) option.textContent = compact ? labels.compact : labels.full;
      });
    }
    const minPrice = root.querySelector('[data-bh-pc-min-price]');
    const maxPrice = root.querySelector('[data-bh-pc-max-price]');
    const rangeMin = root.querySelector('[data-bh-pc-range-min]');
    const rangeMax = root.querySelector('[data-bh-pc-range-max]');
    const rangeShell = root.querySelector('[data-bh-pc-range-shell]');
    const rangeMaxLabel = root.querySelector('[data-bh-pc-range-max-label]');
    const priceValue = root.querySelector('[data-bh-pc-price-value]');
    const freeShipping = root.querySelector('[data-bh-pc-free-shipping]');
    const freeShippingCount = root.querySelector('[data-bh-pc-free-shipping-count]');
    const resetFilter = root.querySelector('[data-bh-pc-reset-filter]');
    const mobileFilter = root.querySelector('[data-bh-pc-mobile-filter]');
    const filters = root.querySelector('[data-bh-pc-filters]');
    const filterBackdrop = root.querySelector('[data-bh-pc-filter-backdrop]');
    const filterClose = root.querySelector('[data-bh-pc-filter-close]');
    const modal = root.querySelector('[data-bh-pc-modal]');
    const modalContent = root.querySelector('[data-bh-pc-modal-content]');
    const modalClose = root.querySelector('[data-bh-pc-modal-close]');

    const logoMapScript = root.querySelector('[data-bh-pc-logo-map]');
    let logoMap = {};
    try { logoMap = JSON.parse(logoMapScript?.textContent || '{}'); } catch { logoMap = {}; }

    let offers = [];
    let requestId = 0;
    let activeControllers = [];
    let marketplaceFilter = 'all';
    let conditionFilter = 'all';
    let highestPrice = 100;
    let selectedAttributeFilters = {};
    let suggestionController = null;
    let suggestionTimer = null;
    let suggestionRequestId = 0;
    let currentQuery = '';
    let selectedResultCategory = null;

    const configuredApi = text(root.dataset.apiUrl);
    const apiUrl = (configuredApi || DEFAULT_API).replace(/\/+$/, '');

    function compactResultsStatus(query) {
      const clean = text(query);
      return clean ? `Ergebnisse für "${clean}"` : 'Ergebnisse';
    }
    function setStatus(message, isError = false) {
      status.textContent = message || '';
      status.classList.toggle('bh-pc__status--error', isError);
    }
    function setResultsStatus(query) {
      const clean = text(query);
      status.classList.remove('bh-pc__status--error');
      status.textContent = '';
      if (!clean) {
        status.textContent = 'Ergebnisse';
        return;
      }
      status.append(document.createTextNode('Ergebnisse für "'));
      const queryAccent = document.createElement('span');
      queryAccent.className = 'bh-pc__status-query';
      queryAccent.textContent = clean;
      status.append(queryAccent, document.createTextNode('"'));
    }
    function setLoading(isLoading) { loading.hidden = !isLoading; }
    function abortSearches() { activeControllers.forEach((controller) => controller.abort()); activeControllers = []; }
    function offerKey(offer) { return `${offer.shop.toLowerCase()}::${offer.id}`; }
    function mergeOffers(incoming) {
      const map = new Map(offers.map((offer) => [offerKey(offer), offer]));
      incoming.forEach((offer) => {
        const key = offerKey(offer); const old = map.get(key);
        map.set(key, old ? { ...old, ...offer, description: offer.description || old.description, images: offer.images.length ? offer.images : old.images, image: offer.image || old.image, url: offer.url || old.url } : offer);
      });
      offers = Array.from(map.values());
    }


    function resultCategories() {
      const map=new Map();
      offers.forEach((offer)=>{
        const id=categoryIdForOffer(offer,currentQuery); const current=map.get(id) || {id,label:categoryLabel(id,currentQuery),count:0}; current.count+=1; map.set(id,current);
      });
      return Array.from(map.values()).sort((a,b)=>{
        const ai=CATEGORY_PRIORITY.indexOf(a.id), bi=CATEGORY_PRIORITY.indexOf(b.id);
        return (ai<0?999:ai)-(bi<0?999:bi) || b.count-a.count || a.label.localeCompare(b.label,'de');
      });
    }
    function marketplaceCategoryCount(id) {
      return offers.filter((offer)=>(marketplaceFilter==='all' || offer.shop===marketplaceFilter) && categoryIdForOffer(offer,currentQuery)===id).length;
    }
    function effectiveResultCategory() {
      const cats=resultCategories(); if(!cats.length) return null;
      if (selectedResultCategory && marketplaceCategoryCount(selectedResultCategory)>0) return selectedResultCategory;
      return cats.find((item)=>marketplaceCategoryCount(item.id)>0)?.id || cats[0].id;
    }
    function renderCategoryChips() {
      if (!categoryBar) return;
      const cats=resultCategories(); const effective=effectiveResultCategory();
      categoryBar.hidden=!cats.length;
      categoryBar.innerHTML=cats.map((item)=>{
        const marketCount=marketplaceCategoryCount(item.id); const active=item.id===effective; const hit=marketplaceFilter!=='all' && marketCount>0 && !active;
        return `<button type="button" class="bh-pc__category-chip${active?' is-active':''}${hit?' is-market-hit':''}" data-bh-pc-category="${escapeHtml(item.id)}" aria-pressed="${active?'true':'false'}"><span>${escapeHtml(item.label)}</span><b>${marketCount}</b></button>`;
      }).join('');
      categoryBar.querySelectorAll('[data-bh-pc-category]').forEach((button)=>button.addEventListener('click',()=>{
        selectedResultCategory=button.dataset.bhPcCategory || null; selectedAttributeFilters={}; buildAttributeFacets(); render();
      }));
    }

    function buildMerchantFilters() {
      const counts = new Map();
      offers.forEach((offer) => counts.set(offer.shop, (counts.get(offer.shop) || 0) + 1));
      const shops = MARKETPLACES.filter((shop) => counts.has(shop)).concat(Array.from(counts.keys()).filter((shop) => !MARKETPLACES.includes(shop)).sort((a,b)=>a.localeCompare(b,'de')));
      merchants.innerHTML = `
        <label class="bh-pc__radio"><input type="radio" name="bh-marketplace" value="all" ${marketplaceFilter === 'all' ? 'checked' : ''}><span>Alle Marktplätze</span><b>${offers.length}</b></label>
        ${shops.map((shop) => `<label class="bh-pc__radio"><input type="radio" name="bh-marketplace" value="${escapeHtml(shop)}" ${marketplaceFilter === shop ? 'checked' : ''}><span>${escapeHtml(shop)}</span><b>${counts.get(shop)}</b></label>`).join('')}`;
      merchants.querySelectorAll('input[type="radio"]').forEach((input) => input.addEventListener('change', () => { marketplaceFilter = input.value; selectedAttributeFilters = {}; renderCategoryChips(); buildAttributeFacets(); render(); }));
    }

    function buildAttributeFacets() {
      const categoryId = effectiveResultCategory();
      const facetOffers = offers.filter((offer) => (marketplaceFilter === 'all' || offer.shop === marketplaceFilter) && (!categoryId || categoryIdForOffer(offer, currentQuery) === categoryId));
      const facets = buildUniversalFacets(facetOffers);
      const validIds = new Set(facets.map((facet) => facet.id));
      Object.keys(selectedAttributeFilters).forEach((id) => { if (!validIds.has(id)) delete selectedAttributeFilters[id]; });
      attributeFacetsHost.innerHTML = facets.map((facet) => {
        const selected = selectedAttributeFilters[facet.id] || [];
        return `<div class="bh-pc__filter-group" data-facet-id="${escapeHtml(facet.id)}">
          <div class="bh-pc__facet-title-row"><h3>${escapeHtml(facet.label)}</h3>${selected.length ? `<button class="bh-pc__facet-clear" type="button" data-bh-pc-facet-clear="${escapeHtml(facet.id)}">Löschen</button>` : ''}</div>
          <div class="bh-pc__facet-list">${facet.values.map((entry) => `<label class="bh-pc__facet-check"><input type="checkbox" value="${escapeHtml(entry.value)}" data-bh-pc-facet="${escapeHtml(facet.id)}" ${selected.includes(entry.value) ? 'checked' : ''}>${facet.id === 'color' ? `<span class="bh-pc__swatch" style="background:${COLOR_SWATCHES[entry.value] || '#ddd'}"></span>` : ''}<span>${escapeHtml(entry.value)}</span><b>${entry.count}</b></label>`).join('')}</div>
        </div>`;
      }).join('');
      attributeFacetsHost.querySelectorAll('[data-bh-pc-facet]').forEach((input) => input.addEventListener('change', () => {
        const id = input.dataset.bhPcFacet; const current = selectedAttributeFilters[id] || [];
        selectedAttributeFilters[id] = input.checked ? Array.from(new Set([...current, input.value])) : current.filter((value) => value !== input.value);
        if (!selectedAttributeFilters[id].length) delete selectedAttributeFilters[id];
        buildAttributeFacets(); render();
      }));
      attributeFacetsHost.querySelectorAll('[data-bh-pc-facet-clear]').forEach((button) => button.addEventListener('click', () => { delete selectedAttributeFilters[button.dataset.bhPcFacetClear]; buildAttributeFacets(); render(); }));
    }

    function updateFilterMeta() {
      highestPrice = Math.max(1, Math.ceil(Math.max(...offers.map((offer) => offer.totalPrice).filter(Number.isFinite), 1)));
      rangeMin.max = String(highestPrice); rangeMax.max = String(highestPrice);
      if (number(rangeMax.value) === null || Number(rangeMax.value) > highestPrice || Number(rangeMax.value) === 100) rangeMax.value = String(highestPrice);
      rangeMaxLabel.textContent = money.format(highestPrice);
      maxPrice.placeholder = String(highestPrice);
      freeShippingCount.textContent = String(offers.filter((offer) => offer.shippingPriceKnown && offer.shippingPrice === 0).length);
      updatePriceUi();
    }

    function updatePriceUi() {
      const min = number(minPrice.value);
      const max = number(maxPrice.value);
      const effectiveMin = min ?? 0;
      const effectiveMax = max ?? highestPrice;
      rangeMin.value = String(Math.max(0, Math.min(effectiveMin, effectiveMax)));
      rangeMax.value = String(Math.max(effectiveMin, Math.min(effectiveMax, highestPrice)));
      const minPct = (Number(rangeMin.value) / highestPrice) * 100;
      const maxPct = (Number(rangeMax.value) / highestPrice) * 100;
      rangeShell.style.setProperty('--bh-range-min', `${minPct}%`);
      rangeShell.style.setProperty('--bh-range-max', `${maxPct}%`);
      priceValue.textContent = `${money.format(effectiveMin)} – ${max === null ? 'Kein Limit' : money.format(max)}`;
    }

    function filteredOffers() {
      const min = number(minPrice.value); const max = number(maxPrice.value);
      const categoryId = effectiveResultCategory();
      let result = offers.filter((offer) => {
        if (marketplaceFilter !== 'all' && offer.shop !== marketplaceFilter) return false;
        if (categoryId && categoryIdForOffer(offer, currentQuery) !== categoryId) return false;
        if (conditionFilter !== 'all' && conditionGroup(offer.condition) !== conditionFilter) return false;
        if (min !== null && offer.totalPrice < min) return false;
        if (max !== null && offer.totalPrice > max) return false;
        if (freeShipping.checked && !(offer.shippingPriceKnown && offer.shippingPrice === 0)) return false;
        if (!offerMatchesAttributeFilters(offer, selectedAttributeFilters)) return false;
        return true;
      });
      const mode = sort.value;
      result = [...result].sort((a,b) => {
        if (mode === 'price-asc') return a.totalPrice - b.totalPrice;
        if (mode === 'price-desc') return b.totalPrice - a.totalPrice;
        if (mode === 'rating-desc') return (b.rating - a.rating) || (a.totalPrice - b.totalPrice);
        const matchRank = (value) => value === 'exact' ? 3 : value === 'related' ? 2 : value === 'accessory' ? 1 : 0;
        return (matchRank(b.matchType) - matchRank(a.matchType)) || (b.relevanceScore - a.relevanceScore) || (a.totalPrice - b.totalPrice);
      });
      return result;
    }

    function shippingValue(offer) {
      if (!offer.shippingPriceKnown) return 'k. A.';
      if (offer.shippingPrice <= 0) return 'KOSTENLOS';
      return money.format(offer.shippingPrice);
    }
    function merchantLogo(shop) {
      const src = safeUrl(logoMap[shop]);
      return src ? `<img class="bh-pc-card__shop-logo" src="${escapeHtml(src)}" alt="${escapeHtml(shop)}" loading="lazy">` : `<strong class="bh-pc-card__shop-name">${escapeHtml(shop)}</strong>`;
    }

    function decodeDescription(value) {
      let result = String(value || '');
      const decoder = document.createElement('textarea');
      for (let i = 0; i < 4; i += 1) {
        decoder.innerHTML = result;
        const decoded = decoder.value;
        if (decoded === result) break;
        result = decoded;
      }
      const holder = document.createElement('div');
      holder.innerHTML = result.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n');
      return (holder.textContent || holder.innerText || '')
        .replace(/\u00a0/g, ' ')
        .replace(/[ \t]+/g, ' ')
        .replace(/\n\s+/g, '\n')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
    }

    function offerCard(offer, index) {
      const image = safeUrl(offer.image); const url = safeUrl(offer.url);
      const extraImages = offer.images.filter((item) => safeUrl(item)).length;
      const hasGallery = extraImages > 1; const hasDescription = Boolean(offer.description);
      return `
        <article class="bh-pc-card" data-offer-index="${index}">
          <div class="bh-pc-card__image-wrap">${image ? `<img class="bh-pc-card__image" src="${escapeHtml(image)}" alt="${escapeHtml(offer.title)}" loading="lazy" decoding="async">` : '<div class="bh-pc-card__image-placeholder">Kein Bild verfügbar</div>'}</div>
          <div class="bh-pc-card__media-links">
            ${hasGallery ? `<button class="bh-pc-card__text-link" type="button" data-bh-pc-gallery="${index}">Weitere Fotos</button>` : ''}
            ${hasGallery && hasDescription ? '<span class="bh-pc-card__separator" aria-hidden="true">|</span>' : ''}
            ${hasDescription ? `<button class="bh-pc-card__text-link" type="button" data-bh-pc-description="${index}">Beschreibung</button>` : ''}
          </div>
          <div class="bh-pc-card__body">
            <div class="bh-pc-card__merchant"><span class="bh-pc-card__shop">${merchantLogo(offer.shop)}</span>${offer.condition ? `<span class="bh-pc-card__condition bh-pc-card__condition--${conditionGroup(offer.condition)}">${escapeHtml(offer.condition)}</span>` : ''}</div>
            <h2 class="bh-pc-card__title">${escapeHtml(offer.title)}</h2>
            <div class="bh-pc-card__meta">${offer.sellerName ? `<p class="bh-pc-card__seller"><strong>Verkäufer:</strong> <span>${escapeHtml(offer.sellerName)}</span></p>` : ''}${offer.deliveryText ? (/auf\s*lager|lagernd|in\s*stock/i.test(offer.deliveryText) ? `<p class="bh-pc-card__stock"><span class="bh-pc-card__stock-dot" aria-hidden="true">•</span><span>${escapeHtml(offer.deliveryText)}</span></p>` : `<p>${escapeHtml(offer.deliveryText)}</p>`) : ''}</div>
            <div class="bh-pc-card__price-row"><div class="bh-pc-card__price-stack">${offer.originalPrice ? `<del class="bh-pc-card__old-price">${money.format(offer.originalPrice)}</del>` : ''}<strong class="bh-pc-card__price">${money.format(offer.price)}</strong></div><span class="bh-pc-card__shipping"><strong class="bh-pc-card__shipping-label">Versand:</strong> <span class="bh-pc-card__shipping-value">${escapeHtml(shippingValue(offer))}</span></span></div>
          </div>
          ${url ? `<a class="bh-pc__offer-button bh-pc-card__offer-row" href="${escapeHtml(url)}" target="_blank" rel="nofollow sponsored noopener">Zum Angebot</a>` : '<span class="bh-pc__offer-button bh-pc-card__offer-row" aria-disabled="true">Angebot nicht verfügbar</span>'}
        </article>`;
    }

    function render() {
      renderCategoryChips();
      if (!offers.length) { grid.innerHTML=''; setCount(''); empty.hidden=true; return; }
      const visible = filteredOffers();
      setCount(`${visible.length} von ${offers.length} Angeboten`);
      empty.hidden = visible.length !== 0;
      grid.innerHTML = visible.map((offer) => offerCard(offer, offers.indexOf(offer))).join('');
      grid.querySelectorAll('[data-bh-pc-gallery]').forEach((button) => button.addEventListener('click', () => openGallery(offers[Number(button.dataset.bhPcGallery)])));
      grid.querySelectorAll('[data-bh-pc-description]').forEach((button) => button.addEventListener('click', () => openDescription(offers[Number(button.dataset.bhPcDescription)])));
      updatePriceUi();
    }

    function openModal(html, kind) {
      modalContent.innerHTML=html;
      modal.dataset.kind = kind || '';
      if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open','');
      document.documentElement.style.overflow='hidden';
    }
    function closeModal() {
      if (typeof modal.close === 'function') modal.close(); else modal.removeAttribute('open');
      document.documentElement.style.overflow='';
      modalContent.innerHTML='';
      modal.dataset.kind='';
    }
    function openGallery(offer) {
      if (!offer) return;
      const images=uniqueStrings(offer.images).map(safeUrl).filter(Boolean);
      if (!images.length) return;
      let active=0;
      const paint=()=>{
        const src=images[active];
        modalContent.innerHTML=`<h2 class="bh-pc-modal__title">Weitere Fotos</h2><div class="bh-pc-modal__viewer">${images.length>1?'<button class="bh-pc-modal__nav bh-pc-modal__nav--prev" type="button" data-bh-gallery-prev aria-label="Vorheriges Bild">‹</button>':''}<img src="${escapeHtml(src)}" alt="${escapeHtml(offer.title)}">${images.length>1?'<button class="bh-pc-modal__nav bh-pc-modal__nav--next" type="button" data-bh-gallery-next aria-label="Nächstes Bild">›</button>':''}</div><div class="bh-pc-modal__counter">${active+1} / ${images.length}</div>`;
        modalContent.querySelector('[data-bh-gallery-prev]')?.addEventListener('click',()=>{active=(active-1+images.length)%images.length;paint();});
        modalContent.querySelector('[data-bh-gallery-next]')?.addEventListener('click',()=>{active=(active+1)%images.length;paint();});
      };
      openModal('', 'gallery'); paint();
    }
    function openDescription(offer) {
      if (!offer || !offer.description) return;
      const description=decodeDescription(offer.description);
      if (!description) return;
      openModal(`<h2 class="bh-pc-modal__title">Beschreibung</h2><div class="bh-pc-modal__description">${escapeHtml(description)}</div>`, 'description');
    }

    function setFiltersOpen(open) {
      const mobile = window.matchMedia('(max-width: 849px)').matches;
      if (!mobile) open = false;
      filters.classList.toggle('is-open', open);
      filterBackdrop?.classList.toggle('is-open', open);
      mobileFilter.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('bh-pc-filter-open', open);
    }

    async function fetchMarketplace(query, marketplace, fast, localRequestId) {
      const controller = new AbortController(); activeControllers.push(controller);
      const timeout = window.setTimeout(() => controller.abort(), marketplace === 'AliExpress' ? (fast ? 8500 : 10500) : (fast ? 5000 : 8500));
      try {
        const url = `${apiUrl}/product-search?query=${encodeURIComponent(query)}&marketplace=${encodeURIComponent(marketplace)}${fast ? '&fast=1' : ''}`;
        const response = await fetch(url, { signal: controller.signal, credentials: 'omit' });
        const data = await response.json().catch(() => null);
        if (!response.ok) throw new Error(data && data.message ? String(data.message) : `HTTP ${response.status}`);
        if (localRequestId !== requestId) return 0;
        const incoming = responseOffers(data, marketplace); if (!incoming.length) return 0;
        mergeOffers(incoming); buildMerchantFilters(); buildAttributeFacets(); updateFilterMeta(); render(); setLoading(false); return incoming.length;
      } catch (error) { if (error && error.name === 'AbortError') return 0; return 0; }
      finally { window.clearTimeout(timeout); activeControllers = activeControllers.filter((item)=>item!==controller); }
    }

    function closeSuggestions() {
      if (suggestionController) suggestionController.abort();
      suggestionController = null;
      window.clearTimeout(suggestionTimer);
      suggestionsPanel.hidden = true;
      suggestionsPanel.innerHTML = '';
      queryInput.setAttribute('aria-expanded', 'false');
    }
    function renderSuggestions(items, query) {
      const suggestions = (Array.isArray(items) ? items : []).slice(0, 8);
      if (!suggestions.length) { suggestionsPanel.innerHTML = '<div class="bh-pc__suggestion-status">Keine Vorschläge gefunden.</div>'; suggestionsPanel.hidden = false; return; }
      suggestionsPanel.innerHTML = suggestions.map((item, index) => {
        const title = text(item && item.title); if (!title) return '';
        const lowerTitle = title.toLocaleLowerCase('de-DE');
        const lowerQuery = text(query).toLocaleLowerCase('de-DE');
        const matchAt = lowerTitle.indexOf(lowerQuery);
        let titleHtml = escapeHtml(title);
        if (lowerQuery && matchAt >= 0) {
          const before = title.slice(0, matchAt);
          const typed = title.slice(matchAt, matchAt + lowerQuery.length);
          const completion = title.slice(matchAt + lowerQuery.length);
          titleHtml = `${before ? `<span class="bh-pc__suggestion-prefix">${escapeHtml(before)}</span>` : ''}<strong class="bh-pc__suggestion-typed">${escapeHtml(typed)}</strong><span class="bh-pc__suggestion-completion">${escapeHtml(completion)}</span>`;
        }
        return `<button type="button" class="bh-pc__suggestion" data-bh-pc-suggestion="${index}" data-title="${escapeHtml(title)}"><span class="bh-pc__suggestion-icon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><circle cx="11" cy="11" r="6.5"></circle><path d="m16 16 4.25 4.25"></path></svg></span><span class="bh-pc__suggestion-title">${titleHtml}</span><span class="bh-pc__suggestion-arrow">↗</span></button>`;
      }).join('');
      suggestionsPanel.hidden = false; queryInput.setAttribute('aria-expanded', 'true');
      suggestionsPanel.querySelectorAll('[data-bh-pc-suggestion]').forEach((button) => {
        button.addEventListener('mousedown', (event) => event.preventDefault());
        button.addEventListener('click', () => { const title = button.dataset.title || ''; queryInput.value = title; closeSuggestions(); searchProducts(title); });
      });
    }
    function scheduleSuggestions() {
      const cleanQuery = text(queryInput.value).replace(/\s+/g, ' ');
      window.clearTimeout(suggestionTimer);
      if (suggestionController) suggestionController.abort();
      if (!cleanQuery) { closeSuggestions(); return; }
      const localId = ++suggestionRequestId;
      suggestionTimer = window.setTimeout(async () => {
        suggestionController = new AbortController();
        suggestionsPanel.hidden = false;
        suggestionsPanel.innerHTML = '<div class="bh-pc__suggestion-status">Vorschläge werden geladen…</div>';
        queryInput.setAttribute('aria-expanded', 'true');
        try {
          const response = await fetch(`${apiUrl}/product-search/suggestions?query=${encodeURIComponent(cleanQuery)}`, { signal: suggestionController.signal, credentials: 'omit' });
          const data = await response.json().catch(() => null);
          if (!response.ok) throw new Error(data && data.message ? String(data.message) : `HTTP ${response.status}`);
          if (localId !== suggestionRequestId) return;
          renderSuggestions(data && data.suggestions, cleanQuery);
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          if (localId !== suggestionRequestId) return;
          suggestionsPanel.innerHTML = '<div class="bh-pc__suggestion-status">Vorschläge momentan nicht verfügbar.</div>';
          suggestionsPanel.hidden = false;
        }
      }, 180);
    }

    async function searchProducts(query) {
      const cleanQuery = text(query).replace(/\s+/g,' '); if (!cleanQuery) { queryInput.focus(); return; }
      requestId += 1; const localRequestId=requestId; abortSearches(); offers=[]; marketplaceFilter='all'; conditionFilter='all'; selectedAttributeFilters={}; currentQuery=cleanQuery; selectedResultCategory=null; closeSuggestions();
      queryInput.value=cleanQuery; root.classList.add('bh-pc--searched'); summary.hidden=false; workspace.hidden=false; grid.innerHTML=''; merchants.innerHTML=''; setCount(''); empty.hidden=true; setStatus(''); setLoading(true);
      minPrice.value=''; maxPrice.value=''; freeShipping.checked=false; sort.value='relevance';
      conditions.querySelector('input[value="all"]').checked = true;
      const url=new URL(window.location.href); url.searchParams.set('q',cleanQuery); history.replaceState({},'',url.toString());
      await Promise.allSettled(MARKETPLACES.map((marketplace)=>fetchMarketplace(cleanQuery,marketplace,true,localRequestId)));
      if (localRequestId !== requestId) return;
      if (!offers.length) { setLoading(false); empty.hidden=false; setStatus('Noch keine Treffer aus der schnellen Suche. Weitere Anbieter werden geprüft …'); }
      else setResultsStatus(cleanQuery);
      Promise.allSettled(MARKETPLACES.map((marketplace)=>fetchMarketplace(cleanQuery,marketplace,false,localRequestId))).then(()=>{
        if (localRequestId !== requestId) return; setLoading(false);
        if (!offers.length) { empty.hidden=false; setStatus('Es konnten keine Angebote geladen werden. Prüfe bitte den Suchbegriff oder die API-Verbindung.',true); }
        else { setResultsStatus(cleanQuery); buildMerchantFilters(); buildAttributeFacets(); updateFilterMeta(); render(); }
      });
    }

    queryInput.setAttribute('aria-autocomplete','list'); queryInput.setAttribute('aria-expanded','false');
    queryInput.addEventListener('input', scheduleSuggestions);
    queryInput.addEventListener('focus',()=>{ if(text(queryInput.value)) scheduleSuggestions(); });
    document.addEventListener('mousedown',(event)=>{ if(!root.contains(event.target) || (!suggestionsPanel.contains(event.target) && event.target!==queryInput)) closeSuggestions(); });
    form.addEventListener('submit',(event)=>{event.preventDefault(); closeSuggestions(); searchProducts(queryInput.value);});
    conditions.querySelectorAll('input[type="radio"]').forEach((input)=>input.addEventListener('change',()=>{conditionFilter=input.value;render();}));
    [minPrice,maxPrice].forEach((input)=>input.addEventListener('input',()=>{ input.value=input.value.replace(/[^0-9.,]/g,''); updatePriceUi(); render(); }));
    rangeMin.addEventListener('input',()=>{ const next=Math.min(Number(rangeMin.value),Number(rangeMax.value)); minPrice.value=next<=0?'':String(next); updatePriceUi(); render(); });
    rangeMax.addEventListener('input',()=>{ const next=Math.max(Number(rangeMax.value),Number(rangeMin.value)); maxPrice.value=next>=highestPrice?'':String(next); updatePriceUi(); render(); });
    freeShipping.addEventListener('change',render); sort.addEventListener('change',render);
    updateResponsiveSortLabels();
    window.addEventListener('resize', updateResponsiveSortLabels, { passive: true });
    resetFilter.addEventListener('click',()=>{ marketplaceFilter='all'; conditionFilter='all'; selectedAttributeFilters={}; minPrice.value=''; maxPrice.value=''; freeShipping.checked=false; sort.value='relevance'; conditions.querySelector('input[value="all"]').checked=true; buildMerchantFilters(); renderCategoryChips(); buildAttributeFacets(); updatePriceUi(); render(); });
    mobileFilter.addEventListener('click',()=>setFiltersOpen(true));
    filterClose?.addEventListener('click',()=>setFiltersOpen(false));
    filterBackdrop?.addEventListener('click',()=>setFiltersOpen(false));
    document.addEventListener('keydown',(event)=>{ if(event.key==='Escape' && filters.classList.contains('is-open')) setFiltersOpen(false); });
    modalClose.addEventListener('click',closeModal); modal.addEventListener('click',(event)=>{if(event.target===modal)closeModal();}); modal.addEventListener('close',()=>{document.documentElement.style.overflow='';modalContent.innerHTML='';});

    const initialQuery=text(root.dataset.initialQuery)||new URL(window.location.href).searchParams.get('q')||''; if(initialQuery) searchProducts(initialQuery);
  });
})();
